// exports.CLIENT_URL = "https://dme.nhaiatms.in"
// exports.BASE_URL = "https://dme.nhaiatms.in/server";
// exports.SOCKET_URL = "https://dme.nhaiatms.in";
// exports.RTSP_BASE_URL = "wss://dme.nhaiatms.in";

exports.CLIENT_URL = "__HTTP_PROTOCOL_PLACEHOLDER__://__HOST_DOMAIN_PLACEHOLDER__"
exports.BASE_URL = "__HTTP_PROTOCOL_PLACEHOLDER__://__HOST_DOMAIN_PLACEHOLDER__/server";
exports.SOCKET_URL = "__HTTP_PROTOCOL_PLACEHOLDER__://__HOST_DOMAIN_PLACEHOLDER__";
exports.RTSP_BASE_URL = "__WS_PROTOCOL_PLACEHOLDER__://__HOST_DOMAIN_PLACEHOLDER__";

// exports.CLIENT_URL = "http://localhost:8080";
// exports.BASE_URL = "http://localhost:3001";
// exports.SOCKET_URL = "http://localhost:3001";
// exports.RTSP_BASE_URL = "ws://localhost";

exports.NIC_DEFAULTS = {
  districtId: 77,
  stateCode: 'HR',
  userId: 974,
  // userId: 107,
  dpCd: 'TP',
  offenceId: 5570,
  vendorName: 'TPL'
}

exports.API_ROUTES = {
  AUTH: {
    LOGIN: "/api/auth/login",
    LOGOUT: "/api/auth/logout",
    SESSION: "/api/auth/session",
    MAP_TOKEN: "/api/auth/map-token",
  },
  DASHBOARD: {
    MASTER_DATA: "/api/dashboard/masters",
    WEATHER: "/api/dashboard/weather",
    LOCATIONS: "/api/dashboard/locations",
    GROUP_DEVICES: "/api/dashboard/devices/group",
    LOCATION_DEVICES: "/api/dashboard/devices/location",
    LOAD_RTSP: "/api/dashboard/rtsp/load",
    STOP_RTSP: "/api/dashboard/rtsp/stop",
  },
  ATCC: {
    GET_TRAFFIC: "/api/atcc/traffic",
    GET_RECORD_BY_ID: "/api/atcc/traffic/",
    GET_FILTERED_TRAFFIC: "/api/atcc/filter/traffic",
    GET_ATCC_FILTERS: "/api/atcc/get-atcc-filters",
  },
  INCIDENTS: {
    INCIDENT_MASTER: "/api/incidents/incident-dropdown-details",
    RAISE_INCIDENT: "/api/incidents/raise-new-incident",
    UPLOAD_IMAGE: "/api/incidents/upload-incident-image",
    INCIDENT_DETAILS: "/api/incidents/all-incidents",
    RESOLVE_INCIDENT: "/api/incidents/resolve",
    RESOLVE_BULK_INCIDENT: "/api/incidents/resolve-all-incidents",
    RESOLVE_SELECTED_INCIDENT: "/api/incidents/resolve-selected-incidents",
    RAISE_CHALLAN: "/api/incidents/generate-challan",
    REPORT_UPDATE: "/api/incidents/update-incident",
    RPO_INCIDENTS: "/api/incidents/rpo-incidents/",
    VIOLATIONS: "/api/incidents/incident-violation",
    VEHICLE_NUMBER: "/api/incidents/update-vehicle-number",
    INCIDENTS_REPORT: "/api/report/excelreport/generate",
    GENERATED_CHALLAN: "/api/incidents/challans",
    VSDS_INCIDENT: "/api/incidents/get-speed-incidents",
    VIDS_INCIDENT: "/api/incidents/get-vids-incidents",
    VIDS_INCIDENT_FILTERS: "/api/incidents/get-vids-filters",
    VSDS_INCIDENT_FILTERS: "/api/incidents/get-vsds-filters",
    CONVERT_INCIDENT: "/api/incidents/convert-incident-to-accident",
    CONVERT_VIDS_TO_INCIDENT: "/api/incidents/convert-vids-to-incident",
    INCIDENT_DETAILS_BY_ID: "/api/incidents/get-incident/",
    INCIDENT_FOR_INCIDENT_MODULE_BY_ID:
      "/api/incidents/get-incident-for-incident-by-id/",
    SHOW_VEHICLE: "/api/incidents/show-vehicle-details",
    ADD_VEHICLE: "/api/incidents/add-vehicle-details",
    DELETE_VEHICLE: "/api/incidents/delete-vehicle-details",
    EDIT_VEHICLE: "/api/incidents/edit-vehicle-details",
    GET_RPO_USERS: "/api/incidents/get-rpo-users",
    GET_INCIDENT_BY_TYPE_ID: "/api/incidents/get-incident-by-type",
    GET_EMERGENCY_SERVICES: "/api/incidents/get-emergency-services",
  },
  ADMINISTRATION: {
    CHANGE_PASSWORD: "/api/admin/change-password",
    GET_LOCATION: "/api/admin/location",
    SAVE_LOCATION: "/api/admin/save-location",
    GET_PACKAGES: "/api/admin/packages",
    CREATE_PACKAGE: "/api/admin/create-package",
    SAVE_PACKAGE: "/api/admin/save-package",
    GET_USERS: "/api/admin/users",
    GET_RPO_USERS: "/api/admin/rpo-users",
    GET_ROLES: "/api/admin/roles",
    CREATE_USER: "/api/admin/create-user",
    CREATE_RPO_USER: "/api/admin/create-rpo-user",
    SAVE_RPO_DEVICES: "/api/admin/save-rpo-devices",
    UPDATE_USER: "/api/admin/update-user",
    GET_COMPANIES: "/api/admin/companies",
    CREATE_COMPANY: "/api/admin/create-company",
    UPDATE_COMPANY: "/api/admin/update-company",
    GET_COMPANY_TYPES: "/api/admin/company-types",
    GET_DEVICE_TYPES: "/api/admin/device-types",
    GET_DEVICES: "/api/admin/devices",
    ADD_DEVICE: "/api/admin/add-device",
    UPDATE_DEVICE: "/api/admin/update-device",
    DELETE_DEVICE: "/api/admin/delete-device",
    CONNECT_ZABBIX: "/api/admin/connect-zabbix",
    VERIFY_ZABBIX: "/api/admin/verify-nms",
    IMPORT_ZABBIX_DEVICES: "/api/admin/import-zabbix-devices",
    CREATE_EMERGENCY_SERVICE: "/api/admin/create-emergency-service",
    EMERGENCY_SERVICE: "/api/admin/emergency-services",
    UPDATE_EMERGENCY_SERVICE: "/api/admin/update-emergency-service",
    GET_API: "/api/admin/show-api",
    CREATE_API: "/api/admin/create-api",
    UPDATE_API: "/api/admin/update-api",
    DELETE_API: "/api/admin/delete-api",
    CREATE_VSDS: "/api/admin/create-vsds",
    SHOW_VSDS: "/api/admin/show-vsds",
    UPDATE_VSDS: "/api/admin/update-vsds",
    DELETE_VSDS: "/api/admin/delete-vsds",
    CREATE_MQTT: "/api/admin/create-mqtt",
    GET_MQTT: "/api/admin/get-mqtt",
    UPDATE_MQTT: "/api/admin/update-mqtt",
    DELETE_MQTT: "/api/admin/delete-mqtt",
    SPEED_RULES: "/api/admin/speed-rules",
    DELETE_SPEED_RULE: "/api/admin/delete-speed-rule",
    NMS_ACCOUNTS: "/api/admin/nms-accounts",
    DELETE_NMS_ACCOUNT: "/api/admin/delete-nms-account",
  },
  VMS: {
    CREATE_VMS: "/api/vms/create-vms-device",
    SHOW_VMS: "/api/vms/get-vms-devices",
    UPDATE_VMS: "/api/vms/update-vms-devices",
    DELETE_VMS: "/api/vms/delete-vms-devices",
  },
  REPORTS: {
    SHOW_REPORTS: "/api/incidents/get-reports",
    SHOW_REPORT_LINKS: "/api/incidents/get-download-report-links",
    INCIDENTS_REPORT: "/api/report/excelreport/generate",
  },
  ACCIDENTS: {
    SHOW_ACCIDENTS: "/api/incidents/show-accidents",
    ACCIDENT_BY_ID: "/api/incidents/get-accident/",
    UPDATE_ACCIDENT: "/api/incidents/update-accident",
  },
};
